module.exports = __WEBPACK_EXTERNAL_MODULE_52__;


//////////////////
// WEBPACK FOOTER
// external {"root":"moment","commonjs2":"moment","commonjs":"moment","amd":"moment"}
// module id = 52
// module chunks = 0